module.exports = __webpack_public_path__ + "img/inbox.3c296463.svg";